export default __webpack_public_path__ + "static/media/V550_SOV.775d20da.pdf";